// extracted by mini-css-extract-plugin
export default {"mainIframeWidth":"375px"};